import { api } from "~/store/api";

import type {
  IGetEventAggregatedBySlugRequestParams,
  IGetEventAggregatedBySlugResponseBody,
  IGetEventMetricsByIdRequestParams,
  IGetEventMetricsByIdResponseBody,
} from "./types";

const API_PREFIX = "/events";

export const eventsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEventAggregatedBySlug: builder.query<
      IGetEventAggregatedBySlugResponseBody,
      IGetEventAggregatedBySlugRequestParams
    >({
      query: ({ slug }) => ({
        url: `${API_PREFIX}/aggregated/slug/${slug}`,
      }),
    }),
    getEventMetricsById: builder.query<
      IGetEventMetricsByIdResponseBody,
      IGetEventMetricsByIdRequestParams
    >({
      query: ({ id }) => ({
        url: `${API_PREFIX}/aggregated/${id}/metrics`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetEventAggregatedBySlugQuery,
  useGetEventMetricsByIdQuery,
} = eventsApi;
